import t from "react";
import { Spinner as n } from "../../Spinner/Spinner.js";
import { ButtonPassword as o } from "./ButtonPassword.js";
const s = e => {
  if (e.state !== "loading" && !e.iconRight && e.type !== "password") return null;
  const r = () => {
    var a;
    return e.state === "loading" && !e.disabled ? t.createElement(n, {
      "aria-label": (a = e.stateMessage) != null ? a : "",
      size: "extra-small"
    }) : e.type === "password" ? t.createElement(o, {
      type: e.typePassword,
      alterType: e.alterTypeInput
    }) : e.iconRight;
  };
  return t.createElement("span", {
    className: "olx-text-input__icon-wrapper",
    "data-position": "right",
    "data-size": e.size,
    "data-type": e.type
  }, r());
};
export { s as RightComponent };